import * as React from 'react';
import { IListItem } from '../classes/list-item';
import { IAppState } from '../classes/app';
import Pager from '../../common/components/pager';
import { ConnectedSort } from '../../common/components/sort-options';
import { ConnectedSortDate, Sort } from '../../common/components/sort-options-date';
import { ConnectedResultePerPageDropdown } from './result-per-page';
import ConnectedDashBoard from '../../common/components/result-dashboard';
import { ConnectedClearAll } from '../../common/components/clear-all';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { FilterType } from '../classes/filter-type';
import { Responsive } from './responsive';
import axios from 'axios';
import * as A11yDialog from 'a11y-dialog';

interface IExternalProps<T = IListItem> {
    listItemComponent: (props: T) => JSX.Element;
    itemType: string;
    providerFilters: string;
    sortByLocation?: boolean;
}

interface StateToProps {
    list: IListItem[];
    numberOfPages: number;
    isLoading: boolean;
    showPrintButton: boolean;
    printResultText: string;
    pdfGenerationMessage: string;
    customDistanceErrorMessage: string;
}

interface DispatchToProps {

}

type IListContainerProps<T = IListItem> = IExternalProps<T> & StateToProps & DispatchToProps;

export class ListContainer extends React.Component<IListContainerProps, null> {
    private dialog: A11yDialog;
    providerRef: React.RefObject<any>;

    constructor(props) {
        super(props)
        this.providerRef = React.createRef();
    }

    componentDidMount() {
        const node = this.providerRef.current as HTMLElement;
        const modal = node.querySelector('#loadingModal') as HTMLElement;
        if (null != modal) {
            this.dialog = new A11yDialog(modal);
        }
    }

    ShowSpinner = () => {
        let inputButton = document.getElementById("unique") as HTMLButtonElement;
        let current = this;

        current.dialog.show();

        setTimeout(function () {

            axios.get("/ProviderResultPage/CheckPDF?url=" + encodeURIComponent(current.props.providerFilters) + "&unique=" + inputButton.attributes["value"].value).then(res => {
                current.dialog.hide();
            });

        }, 1000);

        return true;
    }

    render() {
        return (
            <div ref={this.providerRef}>
                {this.props.itemType == "Providers" ?
                    <div id="loadingModal" className="dialog-container adage-modal-wrapper" aria-hidden="true">
                        <div tabIndex={-1} className="adage-modal-overlay" />
                        <div role="dialog" aria-labelledby="loadingModalTitle" className="adage-modal-dialog">
                            <div className="adage-search-loading-modal loading-spinner-js">
                                <h2 id="loadingModalTitle">{!this.props.pdfGenerationMessage || this.props.pdfGenerationMessage.length === 0 ? "Generating Results" : this.props.pdfGenerationMessage}</h2>
                                <svg width={90} height={90} viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg" className="adage-search-loader">
                                    <path d="M58 30.5C58 15.3122 45.6878 3 30.5 3C15.3122 3 3 15.3122 3 30.5" stroke="#00857A" strokeWidth={5} strokeLinejoin="round" />
                                    <circle cx="30.5" cy="30.5" r="27.5" stroke="url(#gradient)" strokeWidth={5} />
                                    <defs>
                                        <linearGradient id="gradient" x1="12.5" y1={53} x2={56} y2={45} gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#00857A" />
                                            <stop offset={1} stopColor="#00857A" stopOpacity={0} />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                    : null}

                <div className="adage-search-results">
                    {this.props.isLoading || this.props.printResultText === "" ?
                        null
                        :
                        <div className="adage-search-results-header">
                            <div className="adage-search-results-header-display">
                                <ConnectedDashBoard category="Providers" />
                                <ConnectedResultePerPageDropdown property={FilterType.RESULTS_PER_PAGE} title="Results Per Page" />
                            </div>

                            <div className="adage-search-results-header-sort-container">
                                <div className="adage-search-results-header-sort">
                                    {
                                        this.props.itemType == "Events" ?
                                            < ConnectedSortDate property="sort" description={this.props.itemType} title="Sort" defaultOption={{ text: "Date", value: Sort.Date.toString() }} />

                                            : <ConnectedSort property="sort" sortByLocation={this.props.sortByLocation} description={this.props.itemType} title="Sort" defaultOption={{ text: "A - Z", value: Sort.AtoZ.toString() }} />
                                    }
                                </div>
                                {this.props.itemType == "Providers" && this.props.showPrintButton ?
                                    <form action="/ProviderResultPage/PrintPDF" method="post">
                                        <input name="query" type="input" value={this.props.providerFilters} hidden readOnly={true} />
                                        <input type="hidden" value={Math.random()} name="unique" id="unique" readOnly={true} />
                                        <button className="btn" onClick={this.ShowSpinner}>{this.props.printResultText}</button>
                                    </form>
                                    : null}
                            </div>
                        </div>
                    }
                    <Responsive mediaWidth="60rem" />

                    {this.props.isLoading ?
                        <div className="adage-search-loader-container">
                            <h2>Loading Results</h2>
                            <svg width={90} height={90} viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg" className="adage-search-loader">
                                <path d="M58 30.5C58 15.3122 45.6878 3 30.5 3C15.3122 3 3 15.3122 3 30.5" stroke="#00857A" strokeWidth={5} strokeLinejoin="round" />
                                <circle cx="30.5" cy="30.5" r="27.5" stroke="url(#gradient)" strokeWidth={5} />
                                <defs>
                                    <linearGradient id="gradient" x1="12.5" y1={53} x2={56} y2={45} gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#00857A" />
                                        <stop offset={1} stopColor="#00857A" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        :
                        this.props.list.length > 0 || this.props.printResultText === ""?
                            <ul className="adage-search-results-list">
                                {
                                    this.props.list.map(listItem => this.props.listItemComponent(listItem))
                                }
                            </ul>
                            :
                            <div className="adage-search-results-none">
                                <h2>No results found</h2>
                                <p>
                                    Sorry, there are no {this.props.itemType.toLocaleLowerCase()} to display.<br />
                                    Try revising your search or <ConnectedClearAll text="resetting filters" />.
                        </p>
                            </div>
                    }

                    <MediaQuery query={`(min-width: 80.01rem)`}>
                        <Pager maxNumberOfPages={6} />
                    </MediaQuery>
                    <MediaQuery query={`(min-width: 24.01rem) and (max-width: 80rem)`}>
                        <Pager maxNumberOfPages={4} />
                    </MediaQuery>
                    <MediaQuery query={`(max-width: 24rem)`}>
                        <Pager maxNumberOfPages={2} />
                    </MediaQuery>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    return {
        showPrintButton: state.filtersState.showPrintButton,
        printResultText: state.listingState.printResultText,
        customDistanceErrorMessage: state.listingState.customDistanceErrorMessage,
        list: state.listingState.list ? state.listingState.list : [], numberOfPages: state.listingState.numberOfPages, isLoading: state.listingState.currentlyRequesting != null, pdfGenerationMessage: state.listingState.pdfGenerationMessage,
    }
}

export const ConnectedListContainer = connect(mapStateToProps)(ListContainer);